import React from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { AuthContext } from "../../auth/authContext";
import {
  reporteCobranzaRangoFecha,
  reporteCobranzaSerie,
  reporteResumenSerie,
  reporteVentasOrdenesServicioPorFechaAPI,
  reporteVentasPrevisionPorFechaAPI,
} from "../../API/ApiReportes";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { LoadingComponent } from "../../Components/LoadingComponent/LoadingComponent";
import { checkPermisosPorUsuarioPorGuidPantalla } from "../../API/ApiPermisos";
import { SinPermisoComponent } from "../../Components/SinPermisoComponent/SinPermisoComponent";
import MultiselectSeriesComponent from "../../Components/MultiselectSeriesComponent/MultiselectSeriesComponent";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import imageVitanova from "../../Images/LogotipoNegro.png";

import imagenVitaNova from "../../Images/LogotipoNegro.png";
import { ButtonDownloadToXlsComponent } from "../../Components/ButtonDownloadToXlsComponent/ButtonDownloadToXlsComponent";
import CambiarFormatoFechaHelper from "../../Helpers/CambiarFormatoFechaHelper";

const guidVista = "ef433e95-e3b0-4caa-a533-3b599add112e";

const ListToPrintComponent = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  const [totalSalarios, setTotalSalarios] = React.useState(0.0);

  return (
    <div className="print-source " ref={ref}>
      <img
        alt="Vitanova Logo"
        className="mt-3"
        src={imageVitanova}
        width="150"
      />
      <br />

      <h3 className="mt-3">Reporte total ventas previsión por fecha</h3>
      <h6 className="mb-4">
        <small>Reporte general</small>
      </h6>
      <h6 className="mb-4">
        <small>
          de: {CambiarFormatoFechaHelper(props.fechaInicio)} a:{" "}
          {CambiarFormatoFechaHelper(props.fechaFin)}
        </small>
      </h6>

      <div className="container-fluid">
        <div className="row row-cols-5">
          <div className="col">
            <strong>Folio</strong>
          </div>
          <div className="col">
            <strong>Fecha</strong>
          </div>
          <div className="col">
            <strong>Total Orden</strong>
          </div>
          <div className="col">
            <strong>Abono</strong>
          </div>
        </div>
      </div>
      {props.value.map((empleado, index) => (
        <div className="container-fluid" key={index}>
          <div className="row row-cols-5">
            <div className="col">{empleado.folio}</div>
            <div className="col">
              {CambiarFormatoFechaHelper(empleado.fechaCaptura)}
            </div>
            <div className="col">
              {"$ "}{" "}
              {empleado.totalOrden == null
                ? 0
                : parseFloat(empleado.totalOrden)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </div>
            <div className="col">
              {"$ "}{" "}
              {empleado.totalAbonos == null
                ? 0
                : parseFloat(empleado.totalAbonos)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </div>
          </div>
        </div>
      ))}
      <div className="container-fluid">
        <div className="row row-cols-5">
          <div className="col">
            <strong>Total:</strong>
          </div>
          <div className="col"></div>
          <div className="col">
            {"$ "}{" "}
            {parseFloat(props.granTotalOrdenTotal)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </div>
          <div className="col">
            {"$ "}{" "}
            {parseFloat(props.granTotalAbonosTotal)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </div>
        </div>
      </div>
      <br />
    </div>
  );
});

const ComponentToPrint = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  return (
    <div className="print-source " ref={ref}>
      <img alt="Vitanova Logo" src={imageVitanova} width="150" />
      <br />
      <br />
      <br />
      <h3>Reporte total ventas previsión por fecha</h3>
      <br />
      <strong>
        {" "}
        de: {props.fechaInicio} a: {props.fechaFin}
      </strong>
      <br />
      <br />
      <table className="table">
        <tbody>
          <tr>
            <td>Folio</td>
            <td>{props.value.folio}</td>
          </tr>
          <tr>
            <td>Fecha</td>
            <td>{props.value.fecha}</td>
          </tr>
          <tr>
            <td>Total Orden</td>
            <td>
              {" "}
              {"$ "}
              {props.value.totalOrden == null
                ? 0
                : parseFloat(props.value.totalOrden)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
          <tr>
            <td>Abonos</td>
            <td>
              {" "}
              {"$ "}
              {props.value.totalAbonos == null
                ? 0
                : parseFloat(props.value.totalAbonos)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <br />
      __________________________________________________________________
      <br />
      Firma
      <br />
      <br />
      <small style={{ fontSize: "10px" }}>Impreso por: {user.username}</small>
    </div>
  );
});

const ComponentToPrintWrapper = (props) => {
  const componentRef = React.useRef();

  return (
    <TableRow
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell align="center">
        <a target="_self" href={`/ordenservicio/${props.item.folio}/false`}>
          {props.item.folio}
        </a>
      </TableCell>
      <TableCell align="center">
        {CambiarFormatoFechaHelper(props.item.fechaCaptura)}
      </TableCell>
      <TableCell align="center">
        {"$ "}
        {props.item.totalOrden == null
          ? 0.0
          : parseFloat(props.item.totalOrden)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </TableCell>
      <TableCell align="center">
        {"$ "}{" "}
        {props.item.totalAbonos == null
          ? 0.0
          : parseFloat(props.item.totalAbonos)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </TableCell>

      <TableCell align="center">
        {" "}
        <ReactToPrint
          trigger={() => (
            <button type="primary" className="btn btn-sm btn-success">
              Imprimir Recibo
            </button>
          )}
          content={() => componentRef.current}
        />
        <ComponentToPrint
          ref={componentRef}
          value={props.item}
          fechaInicio={props.fechaInicio}
          fechaFin={props.fechaFin}
          granTotalImporteTotal={props.granTotalImporteTotal}
          granTotalPagadoTotal={props.granTotalPagadoTotal}
          granTotalSaldoTotal={props.granTotalSaldoTotal}
        />
      </TableCell>
    </TableRow>
  );
};

export const ReporteTotalVentaOrdenesPorFechas = () => {
  const componentRefListado = React.useRef();

  const todayInicio = new Date();
  const todayFin = new Date();
  const numberOfDaysToAdd = 15;
  const dateInicio = todayInicio.setDate(
    todayInicio.getDate() - numberOfDaysToAdd
  );
  const dateFin = todayFin.setDate(todayFin.getDate());

  const defaultValueInicio = new Date(dateInicio).toISOString().split("T")[0]; // yyyy-mm-dd

  const defaultValueFin = new Date(dateFin).toISOString().split("T")[0]; // yyyy-mm-dd

  const { user, dispatch } = React.useContext(AuthContext);
  const [reporteSerie, setReporteSerie] = React.useState("");
  const [reporteFechaInicial, setReporteFechaInicial] =
    React.useState(defaultValueInicio);
  const [reporteFechaFin, setReporteFechaFin] = React.useState(defaultValueFin);
  const [finalData, setFinalData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [checkPersmissions, setCheckPermissions] = React.useState([]);
  const [permisoParaVisualizar, setPermisoParaVisualizar] =
    React.useState(false);
  const [permisoReporte, setPermisoReporte] = React.useState(false);
  const [seriesSeleccionadas, setSeriesSeleccionadas] = React.useState([]);
  const [granTotalComisionMostrar, setGranTotalComisionMostrar] =
    React.useState(0.0);

  const [granTotalTotalMostrar, setGranTotalTotalMostrar] = React.useState(0.0);

  const [listoParaMandar, setListoParaMandar] = React.useState(false);

  const [granTotalAbonosTotal, setGranTotalAbonosTotal] = React.useState(0.0);
  const [granTotalOrdenTotal, setGranTotalOrdenTotal] = React.useState(0.0);

  React.useEffect(() => {
    let listo = false;

    let granTotalAbonos = 0.0;
    let granTotalOrden = 0.0;

    for (const registro of finalData) {
      granTotalAbonos =
        granTotalAbonos +
        (registro.totalAbonos == null ? 0.0 : parseFloat(registro.totalAbonos));
      granTotalOrden =
        granTotalOrden +
        (registro.totalOrden == null ? 0.0 : parseFloat(registro.totalOrden));
    }

    setGranTotalAbonosTotal(granTotalAbonos);
    setGranTotalOrdenTotal(granTotalOrden);

    return () => {
      listo = true;
    };
  }, [finalData]);

  React.useEffect(() => {
    let ready = false;

    checkPermisosPorUsuarioPorGuidPantalla(user, guidVista).then(
      (resultado) => {
        if (resultado.status == 200) {
          setCheckPermissions(resultado.data);

          for (const permiso of resultado.data) {
            if (
              permiso.guidFuncion == "8f157d70-8d87-4d17-8341-afed9c53b833" &&
              permiso.allowed == 1
            ) {
              setPermisoParaVisualizar(true);
            }
            if (
              permiso.guidFuncion == "6f6c8a19-3db1-4483-bc2a-d70497d27aa3" &&
              permiso.allowed == 1
            ) {
              setPermisoReporte(true);
            }
          }
        }
      }
    );

    let listo = false;

    let granTotalComision = 0.0;
    let granTotaltotal = 0.0;

    setGranTotalTotalMostrar(granTotaltotal);
    setGranTotalComisionMostrar(granTotalComision);
    return () => {
      listo = true;
    };
  }, []);

  return (
    <>
      {permisoParaVisualizar == true && permisoReporte == true ? (
        <>
          <div className="container-fluid mb-2 d-none d-print-block">
            <div className="row">
              <div className="col-12">
                <img src={imagenVitaNova} alt="Logo Vita Nova" height={30} />
              </div>
            </div>
          </div>
          <div className="container-fluid mb-3 mt-2">
            <div className="row row-cols-md-3 d-flex align-items-center">
              <div className="col">
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  id="outlined-basic"
                  label="Fecha Inicio"
                  type="date"
                  variant="standard"
                  value={reporteFechaInicial}
                  onChange={(e) => {
                    setReporteFechaInicial(e.target.value);
                  }}
                />
              </div>
              <div className="col">
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  id="outlined-basic"
                  label="Fecha Fin"
                  type="date"
                  variant="standard"
                  value={reporteFechaFin}
                  onChange={(e) => {
                    setReporteFechaFin(e.target.value);
                  }}
                />
              </div>
              <div className="col d-print-none">
                <button
                  disabled={listoParaMandar}
                  className="btn btn-sm btn-success w-100"
                  onClick={() => {
                    setLoading(true);
                    reporteVentasOrdenesServicioPorFechaAPI(user, {
                      fechaInicio: reporteFechaInicial,
                      fechaFin: reporteFechaFin,
                    }).then((resultado) => {
                      if (resultado.status == 200) {
                        for (const orden of resultado.data) {
                          orden.fechaCaptura = orden.fecha;

                          delete orden.fecha;
                        }

                        setFinalData(resultado.data);
                      }
                      setLoading(false);
                    });
                  }}
                >
                  {" "}
                  Buscar{" "}
                </button>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row row-cols-md-1">
              <div className="col" style={{ textAlign: "right" }}>
                <ButtonDownloadToXlsComponent
                  data={finalData}
                  fileName="Reporte total ventas Ordenes de servicio por fecha"
                />
              </div>
            </div>
                      
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-sm btn-info my-3">
                      Imprimir Reporte General
                    </button>
                  )}
                  content={() => componentRefListado.current}
                />
                <ListToPrintComponent
                  ref={componentRefListado}
                  value={finalData}
                  fechaInicio={reporteFechaInicial}
                  fechaFin={reporteFechaFin}
                  granTotalAbonosTotal={granTotalAbonosTotal}
                  granTotalOrdenTotal={granTotalOrdenTotal}
                />
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row row-cols-1">
              <TableContainer>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Folio</TableCell>
                      <TableCell align="center">Fecha Orden </TableCell>
                      <TableCell align="center">Total Orden</TableCell>
                      <TableCell align="center">Abonos</TableCell>

                      <TableCell align="center">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="center">
                        <strong>Gran Total</strong>
                      </TableCell>
                      <TableCell align="center"></TableCell>

                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalOrdenTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalAbonosTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>

                      <TableCell align="center"></TableCell>
                    </TableRow>

                    {finalData.map((row, index) => (
                      <ComponentToPrintWrapper
                        key={index}
                        item={row}
                        fechaInicio={reporteFechaInicial}
                        fechaFin={reporteFechaFin}
                        granTotalAbonosTotal={granTotalAbonosTotal}
                        granTotalOrdenTotal={granTotalOrdenTotal}
                      />
                    ))}

                    <TableRow>
                      <TableCell align="center">
                        <strong>Gran Total</strong>
                      </TableCell>
                      <TableCell align="center"></TableCell>

                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalOrdenTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>
                          {" "}
                          {"$ "}{" "}
                          {granTotalAbonosTotal
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </strong>
                      </TableCell>

                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          {loading == true ? <LoadingComponent /> : null}
        </>
      ) : (
        <SinPermisoComponent />
      )}
    </>
  );
};
